import React, { useEffect, useState } from "react";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { useSelector } from "react-redux";
import "./Menu.css";
import { toast } from "react-hot-toast";
import TableService from "../../../Services/QRCodeServices/TableSerivce/TableService";

export const MenuItemDetail = ({ item, onClose, selectedTable }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [orgCode, setOrgCode] = useState(null);
  const [localQuantity, setLocalQuantity] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [orderedItems, setOrderedItems] = useState([]);
  const [menuOrderId, setMenuOrderId] = useState(null);
  const [complementary, setComplementary] = useState(false); // Initialize as false
  const [notes, setNotes] = useState();
  console.log("🚀 ~ MenuItemDetail ~ notes:", notes)
  console.log("🚀 ~ MenuItemDetail ~ complementary:", complementary);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
      setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
    }
  }, []);

  useEffect(() => {
    if (selectedTable) {
      fetchOrderedItems();
    }
  }, [selectedTable]);

  const fetchOrderedItems = () => {
    try {
      const storedData = JSON.parse(localStorage.getItem("orders")) || [];
      const tableOrder = storedData.find(
        (order) => order.tableID === selectedTable.id
      );
      if (tableOrder) {
        setOrderedItems(tableOrder.items);
      } else {
        setOrderedItems([]);
      }
    } catch (error) {
      console.error("Error fetching ordered items from localStorage:", error);
      toast.error("Failed to fetch ordered items");
    }
  };

  const saveToLocalStorage = (items) => {
    let storedData = JSON.parse(localStorage.getItem("orders")) || [];
    const tableIndex = storedData.findIndex(
      (order) => order.tableID === selectedTable.id
    );

    const updatedTableOrder = {
      tableID: selectedTable.id,
      items: items,
    };

    if (tableIndex !== -1) {
      // Update existing table order
      storedData[tableIndex] = updatedTableOrder;
    } else {
      // Add new table order
      storedData.push(updatedTableOrder);
    }

    localStorage.setItem("orders", JSON.stringify(storedData));
  };

  const calculateDiscountedPrice = () => {
    const price = item.price;
    const discount = item.discountDetail?.discountPercentage || 0;
    return price - (price * discount) / 100;
  };

  const calculateTotalPrice = () => {
    // If complementary, total price should be 0
    if (complementary) {
      return 0;
    }
    return calculateDiscountedPrice() * localQuantity;
  };

  const handleIncrement = () => {
    setLocalQuantity((prev) => prev + 1);
  };

  const handleDecrement = () => {
    setLocalQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handlePlaceOrder = async () => {
    if (!selectedTable) {
      toast.error("Please select a table before placing an order.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Fetch current API items for the selected table
      const activeTables = await TableService.getActiveTableList();
      const tableData = activeTables.find((t) => t.id === selectedTable.id);
      let apiItems = [];
      if (tableData?.menuOrder?.menuOrderDetails) {
        apiItems = tableData.menuOrder.menuOrderDetails.map((detail) => ({
          menuItemId: detail.menuItemDetail?.id || detail.menuItemId,
        }));
      }

      // Check if the item exists in API items
      const existsInApi = apiItems.some(
        (apiItem) => apiItem.menuItemId === item.id
      );
      if (existsInApi) {
        toast.error(
          "This item is already part of the order. Please update the quantity in the order screen."
        );
        return;
      }

      const discountedPrice = calculateDiscountedPrice();
      const totalPrice = calculateTotalPrice();

      const imageUrl =
        item?.cloudR2ImagePath?.getCDNUrl() ||
        "https://via.placeholder.com/150";

      const newItem = {
        menuItemId: item.id,
        quantity: complementary ? 0 : localQuantity, // Regular quantity is 0 if complementary
        price: discountedPrice,
        totalPrice: totalPrice, // Will be 0 if complementary
        title: item.title,
        imageUrl: imageUrl,
        timestamp: new Date().toISOString(),
        complimentryQuantity: complementary ? localQuantity : 0, // Complementary quantity
        isComplementary: complementary, // Add flag to track complementary status
        notes:notes
      };

      let updatedItems;
      if (orderedItems.length > 0) {
        updatedItems = [...orderedItems];
        const existingItemIndex = updatedItems.findIndex(
          (orderItem) => orderItem.menuItemId === item.id
        );

        if (existingItemIndex !== -1) {
          // Update existing item
          const existingItem = updatedItems[existingItemIndex];

          if (complementary) {
            // Adding complementary quantity
            existingItem.complimentryQuantity =
              (existingItem.complimentryQuantity || 0) + localQuantity;
            existingItem.isComplementary = true;
          } else {
            // Adding regular quantity
            existingItem.quantity += localQuantity;
            existingItem.totalPrice += totalPrice;
          }
        } else {
          updatedItems.push(newItem);
        }

        toast.success("Order added successfully!");
      } else {
        updatedItems = [newItem];
        toast.success("Order added successfully!");
      }

      saveToLocalStorage(updatedItems);
      setOrderedItems(updatedItems);
      onClose();
    } catch (error) {
      console.error("Error processing order:", error);
      setError(error.message || "Failed to process order.");
      toast.error("Failed to process order");
    } finally {
      setLoading(false);
    }
  };

  const handleComplementary = () => {
    setComplementary((prev) => !prev);
  };

  return (
    <div>
      <div className="text-center menu-item-detail-pos mb-3">
        <img
          src={
            item?.cloudR2ImagePath?.getCDNUrl() ||
            "https://via.placeholder.com/150"
          }
          alt={item.title}
          className="img-fluid"
        />
      </div>
      <div className="mb-3">
        <h4 className="fw-bold">{item.title}</h4>
        <p className="text-muted">
          {item.description || "No description available."}
        </p>
      </div>
      <div className="mb-3">
        {item.discountDetail && (
          <p className="mb-1 text-muted">
            <span className="fw-bold">Original Price:</span> Rs. {item.price}
          </p>
        )}
        <div className="d-flex justify-content-between mb-2">
          <Label check htmlFor="isComplementary" className="">
            Complementary
          </Label>
          <FormGroup check className="form-switch">
            <Input
              type="switch"
              id="isComplementary"
              name="isComplementary"
              checked={complementary}
              onChange={handleComplementary}
            />
          </FormGroup>
        </div>
        {item.discountDetail && (
          <p className="mb-1 text-danger">
            <span className="fw-bold">Discount:</span>{" "}
            {item.discountDetail.discountPercentage}% OFF
          </p>
        )}
        <p className="mb-1">
          <span className="fw-bold">Price per item:</span> Rs.{" "}
          {complementary ? "0 (Complementary)" : calculateDiscountedPrice()}
        </p>
      </div>
      <div className="d-flex align-items-center gap-3 mb-3">
        <Button color="light" size="sm" onClick={handleDecrement}>
          -
        </Button>
        <span className="fw-bold">{localQuantity}</span>
        <Button color="light" size="sm" onClick={handleIncrement}>
          +
        </Button>
      </div>
      <div className="mb-3">
        <p className="fw-bold">
          Total Price: Rs.{" "}
          {complementary ? "0 (Complementary)" : calculateTotalPrice()}
        </p>
      </div>
      <div className="mb-3">
      
        <textarea
          className="form-control shadow-sm rounded-3"
          rows="2"
          placeholder="Add some notes"
          value={notes}
          onChange={(e) => setNotes(e.target?.value)}
        />
      </div>
      <div className="text-center">
        <Button
          color="primary"
          size="lg"
          className="w-100"
          onClick={handlePlaceOrder}
          disabled={loading}
        >
          {loading ? "Adding Order..." : "Add Order"}
        </Button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </div>
    </div>
  );
};
